//GeneratorFlag:[NoChange]
import BlogContent from './blog-content';
import BlogCategory from './blog-category';

export default {BlogContent, BlogCategory}
export{BlogContent, BlogCategory}